module.exports = __webpack_public_path__ + "static/media/lock.7bad9afc.svg";